import React, { useEffect, useRef, useState } from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import { Box, Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import ReplayIcon from "@mui/icons-material/Replay";
import { RadioButtons } from "../../components/InputField/RadioButtons";
import { Checklist } from "../Checklist";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        minWidth: "150px",
        overflowX: "hidden",
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
    "& .MuiPaper-elevation": {
        maxWidth: "100%",
        display: "block",
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle
            sx={{
                m: 0.2,
                p: 2,
                pr: 1,
                top: "0",
                left: "0",
                flexGrow: "1",
                position: "fixed",
                width: "99%",
                display: "flex",
                justifyContent: "space-between",
                background: "white",
                zIndex: "9999",
                height: "50px",
                borderBottom: "1px solid #D3D3D3",
            }}
            {...other}>
            {children}
        </DialogTitle>
    );
}

const Filter = (props) => {
    const {
        onClose,
        onClear,
        removeTabIndex,
        fullScreen,
        open,
        sortBy,
        filterBy,
        grade,
        year,
        color,
        colorValue,
        onChange,
        selectedItems,
        ...other
    } = props;

    const handleChange = (record) => {
        onChange(record);
    };

    useEffect(() => {
        console.log("Filter selectedItems", selectedItems);
    }, [selectedItems]);

    useEffect(() => {
        if (open === true && removeTabIndex) {
            setTimeout(() => {
                let red = document.querySelector(".MuiDialog-container");
                if (red) {
                    red.removeAttribute("tabindex");
                }
            }, 100);
        }
    }, [open, removeTabIndex]);

    return (
        <div>
            <BootstrapDialog
                onClose={onClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                {...props}
                tabIndex={false}
                fullScreen={fullScreen}
                sx={{
                    bgcolor: "#000",
                    border: "2px solid black",
                }}>
                <BootstrapDialogTitle id="customized-dialog-title" onClose={props.onClose}>
                    <Typography>
                        <Box sx={{ fontSize: "medium", fontWeight: 600 }}>FILTERS</Box>
                    </Typography>
                    <Box>
                        {props.hideTitle ? (
                            <IconButton
                                aria-label="close"
                                onClick={props.onClear}
                                sx={{
                                    position: "absolute",
                                    right: 10,
                                    top: 10,
                                    color: "black",
                                    borderRadius: "8px",
                                }}>
                                <ReplayIcon sx={{ fontSize: 15 }} />
                                <Typography>
                                    <Box sx={{ fontSize: "small", fontWeight: 600 }}>Clear filters</Box>
                                </Typography>
                            </IconButton>
                        ) : null}
                    </Box>
                </BootstrapDialogTitle>
                <DialogContent
                    sx={{
                        minWidth: false,
                        overflowX: "hidden",
                        p: "0px",
                        ml: 4,
                        mt: 10,
                        mb: 10,
                        letterSpacing: "1.2px",
                    }}>
                    <Box sx={{ ml: 1, p: 0 }}>
                        <Typography>
                            <Box sx={{ fontSize: "small", fontWeight: 600 }}>SORT BY</Box>
                        </Typography>
                        <RadioButtons
                            id={"featured"}
                            headerLabel={"Sort By"}
                            options={sortBy}
                            selectedItems={selectedItems?.featured}
                            value={selectedItems?.featured}
                            onChange={handleChange}
                        />
                        <Typography>
                            <Box sx={{ mt: 2, fontSize: "small", fontWeight: 600 }}>FILTER BY</Box>
                        </Typography>
                        <Typography>
                            <Box sx={{ mt: 2, fontSize: "12px", fontWeight: 600 }}>STYLE/MEDIUM</Box>
                        </Typography>

                        <Checklist
                            id={"style/medium"}
                            options={filterBy}
                            selectedItems={selectedItems?.style}
                            hideLabel
                            columns={1}
                            onChange={handleChange}></Checklist>

                        <Typography>
                            <Box sx={{ mt: 2, fontSize: "12px", fontWeight: 600 }}>GRADE</Box>
                        </Typography>

                        <RadioButtons
                            id={"grade"}
                            headerLabel={"Grade"}
                            options={[...grade]}
                            selectedItems={selectedItems?.grade}
                            value={selectedItems?.grade}
                            onChange={handleChange}
                        />
                        <Typography>
                            <Box sx={{ mt: 2, fontSize: "12px", fontWeight: 600 }}>YEAR</Box>
                        </Typography>
                        <RadioButtons
                            id={"year"}
                            headerLabel={"Year"}
                            options={year}
                            selectedItems={selectedItems?.year}
                            value={selectedItems?.year}
                            onChange={handleChange}
                        />
                        {/* <Typography>
                            <Box sx={{ mt: 2, fontSize: "12px", fontWeight: 600 }}>COLOR</Box>
                        </Typography>

                        <Checklist
                            id={"color"}
                            options={color}
                            selectedItems={selectedItems?.color}
                            hideLabel
                            columns={1}
                            onChange={handleChange}></Checklist> */}
                    </Box>
                </DialogContent>
                <Box
                    sx={{
                        m: 0.2,
                        p: 2,
                        bottom: "0",
                        left: "0",
                        flexGrow: "1",
                        position: "fixed",
                        width: "99%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        background: "white",
                        zIndex: "9999",
                        height: "60px",
                        borderTop: "1px solid #D3D3D3",
                        alignItems: "center",
                    }}>
                    <Button variant="contained" sx={{ bgcolor: "black", mb: 8, width: "40%" }} onClick={props.onClose}>
                        APPLY
                    </Button>
                </Box>
            </BootstrapDialog>
        </div>
    );
};

export { Filter };
